import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainComponent } from './components/main/main.component';
import { LeftSideComponent } from './components/left-side/left-side.component';
import { PolicyComponent } from './components/policy/policy.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { NextBtnComponent } from './components/stepper/next-btn/next-btn.component';
import { PrevBtnComponent } from './components/stepper/prev-btn/prev-btn.component';
import { InsuranceTypeComponent } from './components/steps/insurance-type/insurance-type.component';
import { InsuranePeriodComponent } from './components/steps/insurane-period/insurane-period.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ChoosePolicyComponent } from './components/steps/choose-policy/choose-policy.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { ContactInfoComponent } from './components/steps/contact-info/contact-info.component';
import { PersonalInfoComponent } from './components/steps/personal-info/personal-info.component';
import { InsuranceDaysComponent } from './components/steps/insurance-days/insurance-days.component';
import { AddPassengerComponent } from './components/steps/add-passenger/add-passenger.component';
import { AddPassengerFormComponent } from './components/steps/add-passenger-form/add-passenger-form.component';
import { TravelerInfoComponent } from './components/steps/traveler-info/traveler-info.component';
import { FilledInfoComponent } from './components/steps/filled-info/filled-info.component';
import { InfoCardComponent } from './components/steps/filled-info/info-card/info-card.component';
import { PeronalInfoEditComponent } from './components/steps/filled-info/info-card/peronal-info-edit/peronal-info-edit.component';
import { ContactInfoEditComponent } from './components/steps/filled-info/info-card/contact-info-edit/contact-info-edit.component';
import { PeriodEditComponent } from './components/steps/filled-info/info-card/period-edit/period-edit.component';
import { InsuranceTypeEditComponent } from './components/steps/filled-info/info-card/insurance-type-edit/insurance-type-edit.component';
import { SuccessPageComponent } from './components/steps/success-page/success-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from './service/translate.pipe';
import { TranslationService } from './service/translation.service';
import { TravelService } from './service/travel.service';
import { ConfigProvider, CONFIG_PROVIDER } from './service/config.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CurrencySignPipe } from './service/currency-sign.pipe';
import { InsuranceTypeEditMultipleComponent } from './components/steps/filled-info/info-card/insurance-type-edit-multiple/insurance-type-edit-multiple.component';
import { TokenInterceptorService } from './service/token-interceptor.service';
import { SimplebarAngularModule } from 'simplebar-angular';
import {MatExpansionModule} from '@angular/material/expansion';
import { CarouselModule } from 'ngx-owl-carousel-o';


export function configProviderFactory(provider: ConfigProvider) {
  return () => provider.loadConfig();
}

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    LeftSideComponent,
    PolicyComponent,
    StepperComponent,
    NextBtnComponent,
    PrevBtnComponent,
    InsuranceTypeComponent,
    InsuranePeriodComponent,
    ChoosePolicyComponent,
    ContactInfoComponent,
    PersonalInfoComponent,
    InsuranceDaysComponent,
    AddPassengerComponent,
    AddPassengerFormComponent,
    TravelerInfoComponent,
    FilledInfoComponent,
    InfoCardComponent,
    PeronalInfoEditComponent,
    ContactInfoEditComponent,
    PeriodEditComponent,
    InsuranceTypeEditComponent,
    SuccessPageComponent,
    TranslatePipe,
    CurrencySignPipe,
    InsuranceTypeEditMultipleComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    BrowserAnimationsModule,
    AccordionModule,
    FormsModule,
    ReactiveFormsModule,
    SimplebarAngularModule,
    MatExpansionModule,
    CarouselModule,
    BsDatepickerModule.forRoot(),
  ],
  providers: [
    CONFIG_PROVIDER,
    {
      provide: APP_INITIALIZER,
      useFactory: configProviderFactory,
      deps: [ConfigProvider],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
    ConfigProvider,
    TravelService,
    TranslationService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
